import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n'; // TODO get rid of this import - i18n should not be here

import { TooltipModule } from '../tooltip/tooltip.module';
import { InterviewEvaluationRatingComponent } from './interview-evaluation-rating.component';

@NgModule({
  exports: [InterviewEvaluationRatingComponent],
  imports: [CommonModule, TooltipModule, I18nModule, InterviewEvaluationRatingComponent],
})
export class InterviewEvaluationRatingModule {}
export { InterviewEvaluationRatingComponent } from './interview-evaluation-rating.component';
